import React, { useMemo } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import {
  RelativeDateOffset,
  useAdditionalWorkflowAiService,
} from 'nekst-api';
import AdditionalWorkflowLaunchWrapper from './AdditionalWorkflowLaunchWrapper';
import AdditionalWorkflowVerifyDataPage from './AdditionalWorkflowVerifyDataPage';
import AdditionalWorkflowSelectGroupsPage from './AdditionalWorkflowSelectGroupsPage';
import AdditionalWorkflowKeyDatesPage from './AdditionalWorkflowKeyDatesPage';
import AdditionalWorkflowAllTasksPage from './AdditionalWorkflowAllTasksPage';
import AdditionalWorkflowPartiesPage from './AdditionalWorkflowPartiesPage';
import AdditionalWorkflowConflictsPage from './AdditionalWorkflowConflictsPage';
import AdditionalWorkflowParseContractDataProvider from './AdditionalWorkflowParseContractDataContext';
import { VerifyDataUpdateServiceProvider } from '../Shared/VerifyDataUpdateServiceContext';
import ArchivedProjectChecker from '../ArchivedProjectChecker';

function AiContextProviders(props: { children: React.ReactNode }) {
  const params = useParams();
  const projectId = parseInt(params.id!, 10);
  const planId = parseInt(params.planId!, 10);
  const aiService = useAdditionalWorkflowAiService();

  const updateServiceValue = useMemo(() => ({
    updateName: (name: string) => aiService.updateName(projectId, planId, name),
    updateStringFieldValue: (fieldId: number, value?: string) =>
      aiService.updateStringFieldValue(projectId, planId, fieldId, value),
    updateDateFieldValue: (fieldId: number, value?: Date) =>
      aiService.updateDateFieldValue(projectId, planId, fieldId, value),
    updateNumberFieldValue: (fieldId: number, value?: number) =>
      aiService.updateNumberFieldValue(projectId, planId, fieldId, value),
    updateRelativeDateOffsetValue: (fieldId: number, value?: RelativeDateOffset) =>
      aiService.updateRelativeDateOffsetValue(projectId, planId, fieldId, value),
  }), [projectId, planId]);

  return (
    <AdditionalWorkflowParseContractDataProvider
      projectId={projectId}
      planId={planId}
    >
      <VerifyDataUpdateServiceProvider value={updateServiceValue}>
        {props.children}
      </VerifyDataUpdateServiceProvider>
    </AdditionalWorkflowParseContractDataProvider>
  );
}

export default function AiAdditionalWorkflowRouter() {
  return (
    <AdditionalWorkflowLaunchWrapper>
      <AiContextProviders>
        <Routes>
          <Route
            path="verifydata"
            element={(
              <ArchivedProjectChecker>
                <AdditionalWorkflowVerifyDataPage />
              </ArchivedProjectChecker>
            )}
          />
          <Route
            path="groups"
            element={(
              <ArchivedProjectChecker>
                <AdditionalWorkflowSelectGroupsPage />
              </ArchivedProjectChecker>
            )}
          />
          <Route
            path="conflicts"
            element={(
              <ArchivedProjectChecker>
                <AdditionalWorkflowConflictsPage />
              </ArchivedProjectChecker>
            )}
          />
          <Route
            path="keydates"
            element={(
              <ArchivedProjectChecker>
                <AdditionalWorkflowKeyDatesPage />
              </ArchivedProjectChecker>
            )}
          />
          <Route
            path="alltasks"
            element={(
              <ArchivedProjectChecker>
                <AdditionalWorkflowAllTasksPage />
              </ArchivedProjectChecker>
            )}
          />
          <Route
            path="parties"
            element={(
              <ArchivedProjectChecker>
                <AdditionalWorkflowPartiesPage />
              </ArchivedProjectChecker>
            )}
          />
        </Routes>
      </AiContextProviders>
    </AdditionalWorkflowLaunchWrapper>
  );
}
